//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
    name: 'NavigationUtils',
    computed: {
        ...mapGetters(['getStoredSiteProperties', 'getStoredPage']),
        isExpanded() {
            return this.expanded ? 'true' : 'false';
        },
    },
    data() {
        return {
            animate: false,
            utils: null,
            expanded: false,
            metaLinkFocus: null,
        };
    },
    watch: {
        '$store.getters.getWatchList'() {
            this.animate = true;
            setTimeout(() => {
                this.animate = false;
            }, 500);
        },
    },
    methods: {
        openSearch(event) {
            this.$nuxt.$emit('search.toggle', { event: event });
            this.$nextTick(() => {
                this.$refs.searchMenu.querySelector('input').focus();
            });
            if (!this.expanded) this.expanded = true;
        },
        closeSubmenu() {
            this.$nuxt.$emit('sub-menu.close');
        },
        onSubmenuClosed() {
            this.expanded = false;
            this.$nextTick(() => {
                this.$refs.searchButton.focus();
            });
        },
        onFocus() {
            dispatchEvent(this.metaLinkFocus);
        },
    },
    created() {
        try {
            this.utils = this.getStoredSiteProperties?.meta?.utils;
        } catch (e) {
            console.error(this.utils);
        }
    },
    mounted() {
        this.metaLinkFocus = new Event('focusMetaLink');

        this.$nuxt.$on('submenu.flyout.toggle', () => {
            if (this.expanded) this.expanded = false;
        });
    },
};
